export default function Shield(props) {
    const fill = props.fill ?? '#212121';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 21">
            <path fill={fill} d="M18 13.076L9 21l-9-7.924V0h18v13.076z" />
        </svg>
    );
}
